import { signal } from '@preact/signals'
import { useCallback, useMemo } from 'preact/hooks'
import type AppStore from '../store/AppStore'
import type { FlowProps } from './flowTypes'

export function manualVisible(isEmptyList: boolean): boolean {
  return !isEmptyList
}

export function useManualFlow(store: AppStore): FlowProps {
  const expanded = useMemo(() => signal(false), [])

  const onExpandChange = useCallback(
    async (isExpanded: boolean) => {
      expanded.value = isExpanded
      if (isExpanded) {
        await store.pauseScanning()
      } else {
        await store.resumeScanning()
      }
    },
    [store, expanded]
  )

  const onClearList = useCallback(async () => {
    store.listStore?.removeAll()
    expanded.value = false
    await store.resumeScanning()
  }, [store, expanded])

  const onResumeScanning = useCallback(async () => {
    expanded.value = false
    await store.resumeScanning()
  }, [store, expanded])

  const totalQuantity = store.listStore?.totalQuantity ?? signal(0)
  const items = store.listStore?.resultItems ?? signal([])
  const isEmptyList = store.listStore?.isEmpty.value ?? true

  return {
    totalQuantity,
    items,
    visible: manualVisible(isEmptyList),
    expanded: expanded.value,
    onExpandChange,
    onClearList,
    onResumeScanning,
    showDrawerBottomSheetArrow: true,
  }
}
